import { motion } from "framer-motion";
import { EASE } from "./ui-bits";

const word = "ELEVATE ESTATES";

const Loader = () => (
  <motion.div
    className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-obsidian"
    data-testid="loader"
    exit={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: EASE }}
  >
    <motion.img
      src="/assets/logo-light.png"
      alt="Elevate Estates"
      className="h-16 w-16 object-contain"
      initial={{ opacity: 0, scale: 0.85, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.9, ease: EASE }}
    />
    <div className="mt-6 flex overflow-hidden text-[13px] font-medium uppercase tracking-[0.5em] text-ivory">
      {word.split("").map((c, i) => (
        <motion.span
          key={i}
          className="inline-block will-change-transform"
          initial={{ y: "120%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.35 + i * 0.035, ease: EASE }}
        >
          {c === " " ? "\u00A0" : c}
        </motion.span>
      ))}
    </div>
    <motion.div
      className="mt-6 h-px bg-champagne"
      initial={{ width: 0 }}
      animate={{ width: 120 }}
      transition={{ duration: 1.1, delay: 0.6, ease: EASE }}
    />
    <motion.div
      className="mt-4 text-[10px] uppercase tracking-[0.32em] text-stone"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.1 }}
    >
      Commercial Real Estate Advisory · Bengaluru
    </motion.div>
  </motion.div>
);

export default Loader;
